import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import "./styles.css";



export default function WheelPackageModal({ show, data, onClose }) {
    const navigate = useNavigate();
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;


    const [years, setYears] = useState([]);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [submodels, setSubmodels] = useState([]);

    const [loadingYears, setLoadingYears] = useState(false);
    const [loadingMakes, setLoadingMakes] = useState(false);
    const [loadingModels, setLoadingModels] = useState(false);
    const [loadingSubmodels, setLoadingSubmodels] = useState(false);

    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const submodelRef = useRef(null);

    const [isMatched, setIsMatched] = useState(false);
    const [fitmentError, setFitmentError] = useState("");
    const [loadingFitment, setLoadingFitment] = useState(false);

    const storedVehicle = JSON.parse(localStorage.getItem('vehical_details') || '{}');
    const variantName = storedVehicle?.variant_name;

    const [year, setYear] = useState(storedVehicle?.year || '');
    const [make, setMake] = useState(storedVehicle?.make || '');
    const [model, setModel] = useState(storedVehicle?.model || '');
    const [submodel, setSubmodel] = useState(storedVehicle?.variant || '');

    const [yearLabel, setYearLabel] = useState(storedVehicle?.yearLabel || 'Year');
    const [makeLabel, setMakeLabel] = useState(storedVehicle?.makeLabel || 'Make');
    const [modelLabel, setModelLabel] = useState(storedVehicle?.modelLabel || 'Model');
    const [subLabel, setSubLabel] = useState(storedVehicle?.variantLabel || 'Submodel');
    const canSearch = !!year && !!make && !!model;



    useEffect(() => {
        loadYears();
    }, []);

    useEffect(() => {
        if (!storedVehicle?.year) return;

        loadMakes(storedVehicle.year);

        if (!storedVehicle?.make) return;
        loadModels(storedVehicle.year, storedVehicle.make);

        if (!storedVehicle?.model) return;
        loadSubmodels(storedVehicle.year, storedVehicle.model);
    }, []);

    useEffect(() => {
        if (years.length > 0 && year) {
            const found = years.find(opt => String(opt.value) === String(year));
            if (found) setYearLabel(found.label);
        }
    }, [years, year]);

    useEffect(() => {
        if (makes.length > 0 && make) {
            const found = makes.find(opt => String(opt.value) === String(make));
            if (found) setMakeLabel(found.label);
        }
    }, [makes, make]);

    useEffect(() => {
        if (models.length > 0 && model) {
            const found = models.find(opt => String(opt.value) === String(model));
            if (found) setModelLabel(found.label);
        }
    }, [models, model]);

    useEffect(() => {
        if (submodels.length > 0 && submodel) {
            const found = submodels.find(opt => String(opt.value) === String(submodel));
            if (found) setSubLabel(found.label);
        }
    }, [submodels, submodel]);

    const loadYears = async () => {
        setLoadingYears(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getYear`);
            setYears(data?.data || []);
        } catch (err) {
            console.error('Failed to load years', err);
        } finally {
            setLoadingYears(false);
        }
    };

    const loadMakes = async (yr) => {
        if (!yr) return;
        setLoadingMakes(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getMakeByYear/${yr}`);
            setMakes(data?.data || []);
        } catch (err) {
            console.error('Failed to load makes', err);
        } finally {
            setLoadingMakes(false);
        }
    };

    const loadModels = async (yr, mk) => {
        if (!yr || !mk) return;
        setLoadingModels(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getModelByMake/${yr}/${mk}`);
            setModels(data?.data || []);
        } catch (err) {
            console.error('Failed to load models', err);
        } finally {
            setLoadingModels(false);
        }
    };

    const loadSubmodels = async (yr, md) => {
        if (!yr || !md) return;
        setLoadingSubmodels(true);
        try {
            const { data } = await axios.get(`${mainUrl}/api/getSubModelByModel/${yr}/${md}`);
            setSubmodels(data?.data || []);
        } catch (err) {
            console.error('Failed to load submodels', err);
        } finally {
            setLoadingSubmodels(false);
        }
    };

    const handleYearChange = (option) => {
        if (!option) return;
        setYear(option.value);
        setYearLabel(option.label);

        setMake(''); setMakeLabel('Make');
        setModel(''); setModelLabel('Model');
        setSubmodel(''); setSubLabel('Submodel');
        setMakes([]); setModels([]); setSubmodels([]);

        loadMakes(option.value);
        setTimeout(() => makeRef.current?.focus(), 100);
    };

    const handleMakeChange = (option) => {
        if (!option) return;
        setMake(option.value);
        setMakeLabel(option.label);

        setModel(''); setModelLabel('Model');
        setSubmodel(''); setSubLabel('Submodel');
        setModels([]); setSubmodels([]);

        loadModels(year, option.value);
        setTimeout(() => modelRef.current?.focus(), 100);
    };

    const handleModelChange = (option) => {
        if (!option) return;
        setModel(option.value);
        setModelLabel(option.label);

        setSubmodel(''); setSubLabel('Submodel');
        setSubmodels([]);

        loadSubmodels(year, option.value);
        setTimeout(() => submodelRef.current?.focus(), 100);
    };

    const handleSubmodelChange = (option) => {
        if (!option) return;
        setSubmodel(option.value);
        setSubLabel(option.label);
    };



    const handleSearch = async () => {
        if (!canSearch) return;

        const vehicle = {
            year: year,
            make: make,
            make_name: makeLabel,
            model: model,
            model_name: modelLabel,
            variant: submodel,
            variant_name: subLabel,
        };

        localStorage.setItem('vehical_details', JSON.stringify(vehicle));

        setLoadingFitment(true);
        setFitmentError("");
        setIsMatched(false);

        try {
            const response = await axios.get(
                `${mainUrl}/api/wheels/getWheelsDataWithSearchByVehical?year=${year}&make=${make}&model=${model}&variant=${submodel}&variantName=${variantName}`
            );

            const uniqueFitmentNotes = response?.data?.details?.uniqueFitmentNotes;

            if (uniqueFitmentNotes?.length > 0) {
                setIsMatched(true);
            } else {
                setFitmentError("This product does not fit your selected vehicle.");
            }
        } catch (error) {
            console.error("Fitment check failed:", error);
            setFitmentError("Something went wrong. Please try again.");
        } finally {
            setLoadingFitment(false);
        }
    };


    const getLiftCategory = (kitType) => {
        if (!kitType) return null;

        const match = kitType.match(/(\d+(\.\d+)?)/);
        if (!match) return null;

        const inches = parseFloat(match[0]);

        if (inches < 3) return "LEVEL LIFT";
        if (inches < 5) return "3 INCH LIFT";
        if (inches < 8) return "6 INCH LIFT";
        return "DEEP LIP UP TO 16 INCH WIDTH";
    };

    const handleShopWheels = () => {
        const kitType = data?.kit_type;

        if (kitType) {
            const liftCategory = getLiftCategory(kitType);
            localStorage.setItem('setWheelsSelectedFitmentType', JSON.stringify(liftCategory));
        }

        const url = `/wheels-search-by-vehical?year=${year}&make=${make}&model=${model}&variant=${submodel || ''}`;
        window.open(url, '_blank');
    };

    const handleShopTires = () => {
        const kitType = data?.kit_type;

        if (kitType) {
            const liftCategory = getLiftCategory(kitType);
            localStorage.setItem('setSelectedFitmentType', JSON.stringify(liftCategory));
        }

        const url = `/tires/tires-with-vehicle-lifted?year=${year}&make=${make}&model=${model}&variant=${submodel || ''}`;
        window.open(url, '_blank');
    };

    const handleShopPackages = () => {
        const kitType = data?.kit_type;

        if (kitType) {
            const liftCategory = getLiftCategory(kitType);
            localStorage.setItem('packages_selectedFitmentType', liftCategory);
        }

        const url = `/wheel-tire-packages/lifted?year=${year}&make=${make}&model=${model}&variant=${submodel || ''}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };



    if (!show) return null;

    return (
        <div className="wheel-modal-overlay">
            <div className="wheel-modal-container">
                <button className="wheel-modal-close" onClick={onClose}>
                    ✕
                </button>

                <div className="wheel-top-bar">
                    <h4 className="wheel-small-title">WHEEL + TIRE PACKAGE</h4>
                    <h2 className="wheel-main-title">SHOP WHEELS + TIRES</h2>
                </div>

                <div className="wheel-modal-content">
                    <div className="wheel-modal-left">
                        <div className="wheel-form-section">
                            {/* <p style={{ textAlign: "center", fontSize: "14px" }}>Tell us about your vehicle and desired ride height so we can get you to the perfect Wheel & Tire combinations available</p> */}
                            <h5 style={{ textAlign: "center", fontWeight: 'bold' }}>
                                ENTER YOUR VEHICLE
                            </h5>

                            <div className="wheel-form-grid">
                                <Select
                                    options={years}
                                    value={year ? { value: year, label: yearLabel } : null}
                                    onChange={handleYearChange}
                                    placeholder="Year"
                                    isLoading={loadingYears}
                                    isSearchable={true}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />

                                <Select
                                    ref={makeRef}
                                    options={makes}
                                    value={make ? { value: make, label: makeLabel } : null}
                                    onChange={handleMakeChange}
                                    placeholder="Make"
                                    isLoading={loadingMakes}
                                    isDisabled={!year || loadingMakes}
                                    isSearchable={true}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />

                                <Select
                                    ref={modelRef}
                                    options={models}
                                    value={model ? { value: model, label: modelLabel } : null}
                                    onChange={handleModelChange}
                                    placeholder="Model"
                                    isLoading={loadingModels}
                                    isDisabled={!make || loadingModels}
                                    isSearchable={true}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />

                                <Select
                                    ref={submodelRef}
                                    options={submodels}
                                    value={submodel ? { value: submodel, label: subLabel } : null}
                                    onChange={handleSubmodelChange}
                                    placeholder="Submodel"
                                    isLoading={loadingSubmodels}
                                    isDisabled={!model || loadingSubmodels}
                                    isSearchable={true}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />

                                <button
                                    className={`wheel-continue-btn w-100 mt-4 py-2 fw-bold ${canSearch ? '' : 'disabled'}`}
                                    disabled={!canSearch || loadingFitment}
                                    onClick={handleSearch}
                                >
                                    {loadingFitment ? 'LOADING...' : 'FIND MATCHING PACAKGE'}
                                </button>

                            </div>

                            {fitmentError && (
                                <div className="mt-3">
                                    <div class="fit-status error visible" id="fit-status"> <span class="fit-icon">⚠️</span>
                                        <div class="fit-text"> <strong>Fitment Warning</strong>
                                            <small>{fitmentError} Please select another YMM </small>
                                        </div>
                                    </div>
                                    <button
                                        onClick={onClose}
                                        className="wheel-continue-button w-100 mt-4"
                                    >
                                        Continue with selected vehicle
                                    </button>
                                </div>
                            )}

                            {isMatched && (
                                <div className="wheel-match-sections mt-4">
                                    {/* Wheels */}
                                    <div className="match-box">
                                        <div className="match-header">
                                            <img src="/category/wheels.png" alt="Wheels" className="match-icon" />
                                            <div>
                                                <h5>WHEELS</h5>
                                                <p>Browse wheels compatible with your vehicle.</p>
                                            </div>
                                        </div>

                                        <button
                                            className="btn btn-dark w-100 mt-3"
                                            onClick={handleShopWheels}
                                        >
                                            Shop Wheels
                                        </button>
                                    </div>

                                    {/* Tires */}
                                    <div className="match-box">
                                        <div className="match-header">
                                            <img src="/category/tires.png" alt="Tires" className="match-icon" />
                                            <div>
                                                <h5>TIRES</h5>
                                                <p>Browse tires compatible with your vehicle.</p>
                                            </div>
                                        </div>

                                        <button
                                            className="btn btn-dark w-100 mt-3"
                                            onClick={handleShopTires}
                                        >
                                            Shop Tires
                                        </button>
                                    </div>

                                    {/* Wheel & Tire Package */}
                                    <div className="match-box">
                                        <div className="match-header">
                                            <img
                                                // src="/category/wheel-&tire-accessories.png"
                                                src="https://images.ctfassets.net/auc1ums13y5u/7u1t8rtF38yFDplSxgZ2mY/ec08eba644754f5619684fdffa977aaf/tire-wheel-mb.png?h=137"
                                                alt="Wheel & Tire Package"
                                                className="match-icon"
                                            />
                                            <div>
                                                <h5>WHEEL & TIRE PACKAGE</h5>
                                                <p>Browse wheel and tire packages for your vehicle.</p>
                                            </div>
                                        </div>

                                        <button
                                            className="btn btn-dark w-100 mt-3"
                                            onClick={handleShopPackages}
                                        >
                                            Shop Packages
                                        </button>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="wheel-modal-right">
                        <img
                            src="https://images.ctfassets.net/auc1ums13y5u/1topN5EjJChaNFbGROHTgl/1782be23438d49d0d4c7521680a6dac3/tire-wheel-pkg-bronco.jpg"
                            alt="Wheel & Tire Package"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}